import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { BlogPostsWidget } from './BlogPostsWidget'

class HoldstyringBlogElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return BlogPostsWidget
  }

  // Supported HTML attributes:
  //   limit="3"             — number of newest posts (1-50, default: 6)
  //   show-images="false"   — hide featured images (default: visible)
  protected getWidgetProps() {
    const limitRaw = this.getAttribute('limit')
    const limit = limitRaw && /^\d+$/.test(limitRaw) ? parseInt(limitRaw, 10) : null
    return {
      limit,
      showImages: this.getAttribute('show-images') !== 'false',
    }
  }
}

if (!customElements.get('holdstyring-blog')) {
  customElements.define('holdstyring-blog', HoldstyringBlogElement)
}

export { HoldstyringBlogElement }
